import React from "react";
import { formatDate } from "features/shared/helpers/Formatters";

interface IProps {
  date: Date,
  formatOptions?: Intl.DateTimeFormatOptions
}

const DateFormatter: React.FC<IProps> = (props) => {
  const getFormattedDate = (date: Date, formatOptions?: Intl.DateTimeFormatOptions) =>
    formatDate(date, formatOptions);

  return <>{getFormattedDate(props.date, props.formatOptions)}</>;
};

export default DateFormatter;